import { $$ } from 'utils/dom';
import Lightbox from 'modules/lightbox/Lightbox';

const imageGalleries = $$('.image-gallery');

if (imageGalleries.length) {
  imageGalleries.forEach(imageGallery => {
    const lightbox = new Lightbox(imageGallery, {
      selector: '.lightbox-toggle',
    });
    lightbox.init();
  });
}
